export default __webpack_public_path__ + "images/0x40379a439d4f6795b6fc9aa5687db461677a2dba.png";